const sidebarMenu = [
  {
    label: 'Courses',
    route: '/courses/'
  },
  {
    label: 'Lessons',
    route: '/lessons/'
  },
  {
    label: 'Topics',
    route: '/topics/'
  },
  {
    label: 'Your profile',
    route: '/profile/'
  }
]

export default sidebarMenu
